import { useEffect, useState } from 'react'
import { Workbox } from 'workbox-window'

const oneHourInMs = 3600000

let appUpdateAvailable = false
const appUpdateListeners = new Set<() => void>()

const notifyUpdateAvailable = () => {
  appUpdateAvailable = true
  for (const listener of appUpdateListeners) listener()
}

export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    const wb = new Workbox('/service-worker.js')
    wb.addEventListener('activated', event => {
      // `event.isUpdate` will be true if another version of the service
      // worker was controlling the page when this version was registered.
      if (event.isUpdate) {
        console.info('trigger app update available')
        wb.update()
      }
    })

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.info('service worker controller changed')
      notifyUpdateAvailable()
    })

    void wb.register()
    setInterval(() => {
      console.info('trigger event by interval')
      wb.update()
    }, oneHourInMs)
  }
}

export const useAppUpdateAvailable = () => {
  const [available, setAvailable] = useState(appUpdateAvailable)

  useEffect(() => {
    const listener = () => setAvailable(true)
    appUpdateListeners.add(listener)
    return () => {
      appUpdateListeners.delete(listener)
    }
  }, [])

  return available
}
